import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ActionLinkHandler from './ActionLinkHandler';
import ActionBoxPreview from './ActionBoxPreview';

// Test page to preview ActionLinkHandler UI states.
// Usage examples:
// - /app/test/action-link?state=loading
// - /app/test/action-link?state=success
// - /app/test/action-link?state=error
// - /app/test/action-link?state=message
const ActionLinkTestPage = () => {
  const [searchParams] = useSearchParams();
  const state = searchParams.get('state') || 'success';
  const mode = searchParams.get('mode') || 'box'; // 'box' to preview standalone card, 'handler' to preview handler
  const withBg = searchParams.get('bg') === 'true';
  if (mode === 'box') {
    return <ActionBoxPreview state={state} withBackground={withBg} />;
  }
  return <ActionLinkHandler testMode={state} />;
};

export default ActionLinkTestPage;


